import { COOKIE, STATES } from './config.js';
import { setUdidCookieAndReport } from './modules/cookie.js';
import { debug } from './modules/debug.js';
import { fetchUdid } from './modules/requests.js';
import { COOKIE as COOKIE_UTILS } from '@iva/utils';
const markerRegexSimple = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const markerRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}@[0-9]+$/;
const oldMarkerRegex = /^[\w-]{32}@\d+@\d+$/;
const refreshUdid = async (forceCookie) => {
    let udid;
    try {
        udid = await fetchUdid();
    }
    catch (error) {
        debug({ message: `Error during fetching udid: ${error}`, state: STATES.ERROR });
        return;
    }
    const markerCookie = `${udid}@${new Date().getTime()}`;
    debug({ message: `Refreshing mark to be saved into cookie: "udid=${markerCookie}"` });
    await setUdidCookieAndReport(markerCookie, forceCookie);
};
/**
 * Fetch and saving a cookie `udid` (unique domain identifier), if cookie is not present
 */
export const marker = async (forceCookie = false) => {
    let markerCookie = COOKIE_UTILS.getCookie(COOKIE.NAME);
    debug({ message: `Checking currently stored cookies: "${markerCookie}"`, state: STATES.START });
    if (markerCookie) {
        if (markerRegexSimple.test(markerCookie)) {
            // add '@refresh' to the cookie
            markerCookie = `${markerCookie}@${new Date().getTime()}`;
            debug({ message: `Refreshing mark to be saved into cookie: "udid=${markerCookie}"` });
            await setUdidCookieAndReport(markerCookie, true);
        }
        else if (markerRegex.test(markerCookie)) {
            // check refresh timestamp after '@'
            const [markerCookieValue, markerCookieRefresh] = markerCookie.split('@');
            const refreshTimestamp = markerCookieRefresh ? parseInt(markerCookieRefresh, 10) : 0;
            if (Date.now() - refreshTimestamp > COOKIE.REFRESH_DAYS * COOKIE.INTERVAL_24) {
                // refresh cookie
                markerCookie = `${markerCookieValue}@${new Date().getTime()}`;
                await setUdidCookieAndReport(markerCookie, true);
            }
        }
        else if (oldMarkerRegex.test(markerCookie)) {
            // cookie match old format
            const [markerCookieValue, markerCookieCreation, markerCookieRefresh] = markerCookie.split('@');
            // TODO: remove old cookie and use new format
            const refreshTimestamp = markerCookieRefresh ? parseInt(markerCookieRefresh, 10) : 0;
            if (Date.now() - refreshTimestamp > COOKIE.REFRESH_DAYS * COOKIE.INTERVAL_24) {
                markerCookie = `${markerCookieValue}@${markerCookieCreation}@${new Date().getTime()}`;
                debug({ message: `Refreshing old mark to be saved into cookie: "udid=${markerCookie}"` });
                await setUdidCookieAndReport(markerCookie, true);
            }
        }
    }
    else {
        await refreshUdid(forceCookie);
    }
    debug({ message: 'Marker is finished', state: STATES.DONE });
};
/**
 * Generating and saving a cookie `udid` (unique domain identifier) without consent check
 * Relies on fact, that consent exists during function call
 */
export const markerForceCookie = async () => {
    debug({ message: 'Force creating mark.' });
    await marker(true);
};
